export const handleBackNavigation = () => window.history.back()
